<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="3" class="my-4">
          <b-card bg-variant="dark" text-variant="dark" no-body class="shadow">
            <template #header>
              <h2 class="text-light">
                {{ currentPackage.title }}
                <b-button
                  variant="warning"
                  class="float-right"
                  v-b-modal.modal-editPackage
                >
                  <font-awesome-icon icon="edit" class="mr-2" />Uredi paket
                </b-button>
              </h2>
            </template>
            <b-list-group flush>
              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
                >Je charity donacija?
                <b-badge
                  :variant="currentPackage.rewards ? 'success' : 'danger'"
                >
                  {{ currentPackage.rewards ? "DA" : "NE" }}</b-badge
                >
              </b-list-group-item>
              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
                >Je paket aktiven?
                <b-badge
                  :variant="currentPackage.is_active ? 'success' : 'danger'"
                >
                  {{ currentPackage.is_active ? "DA" : "NE" }}</b-badge
                >
              </b-list-group-item>
              <div v-if="currentPackage.rewards">
                <b-list-group-item
                  >T&C url:
                  <a :href="currentPackage.reward_terms" class="float-right">{{
                    currentPackage.reward_terms
                  }}</a>
                </b-list-group-item>
              </div>
            </b-list-group>
          </b-card>

          <b-card bg-variant="secondary" class="shadow mt-4">
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="muted">
                  Tekst na začetku
                </h4>
                <HelperImageUpload
                  v-bind:imgType="{
                    type: 'package',
                    imgType: 1,
                    label: 'Start',
                    id: currentPackage.id,
                  }"
                />
              </div>
            </template>
            <b-card-body v-html="currentPackage.intro_text"> </b-card-body>
            <b-card-footer v-if="currentPackage.intro_img">
              <img
                class="img-fluid"
                :src="`${helperImgPath}/${currentPackage.intro_img}`"
              />
            </b-card-footer>
          </b-card>
          <b-card bg-variant="secondary" class="shadow mt-4">
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="muted">
                  Tekst na koncu
                </h4>
              </div>
            </template>
            <b-card-body v-html="currentPackage.finish_text"> </b-card-body>
          </b-card>
          <b-card bg-variant="secondary" class="shadow mt-4">
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="muted">
                  Tekst pri formah
                </h4>
                <HelperImageUpload
                  v-bind:imgType="{
                    type: 'package',
                    imgType: 2,
                    label: 'Forms',
                    id: currentPackage.id,
                  }"
                />
              </div>
            </template>
            <b-card-body v-html="currentPackage.form_text"> </b-card-body>
            <b-card-footer v-if="currentPackage.form_img">
              <img
                class="img-fluid"
                :src="`${helperImgPath}/${currentPackage.form_img}`"
              />
            </b-card-footer>
          </b-card>
        </b-col>
        <b-col cols="3" class="mt-md-4">
          <b-card>
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="muted flex-grow-1">
                  Form
                </h4>
                <b-button
                  variant="danger"
                  class="mr-2"
                  v-b-toggle.sidebar-formDelete
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
                <b-button variant="info" v-b-toggle.sidebar-formEditor>
                  <font-awesome-icon icon="plus" />
                </b-button>
              </div>
            </template>
            <FormulateForm
              :schema="currentPackage.form"
              v-model="formFields"
              class="form-group"
            >
            </FormulateForm>
          </b-card>
        </b-col>
        <b-col cols="6" class="mt-md-4">
          <b-button variant="success" v-b-modal.modal-addProjectToPackage>
            <font-awesome-icon icon="plus-circle" class="mr-2" />Add
            project</b-button
          >
          <b-button variant="warning" class="mx-2" @click="updateOrder()">
            <font-awesome-icon icon="save" class="mr-2" /> Save order</b-button
          >
          |
          <b-button
            variant="light"
            class="mx-2"
            :href="
              `${apiUrl}/api/dashboard/packages/${currentPackage.id}/respondents?jwt=${token}`
            "
            target="_blank"
          >
            <font-awesome-icon icon="users" class="mr-2" />
            Respondents</b-button
          >
          <b-button
            variant="light"
            class="mx-2"
            :href="
              `${apiUrl}/api/dashboard/packages/${currentPackage.id}/results?jwt=${token}`
            "
            target="_blank"
          >
            <font-awesome-icon icon="users" class="mr-2" /> Results</b-button
          >
          <b-button
            variant="info"
            class="mx-2"
            :href="`${frontUrl}/${currentPackage.slug}`"
            target="_blank"
          >
            <font-awesome-icon icon="link" class="mr-2" /> Public link
          </b-button>
          <hr />

          <div v-if="currentPackage.projects">
            <table
              class="table table-striped table-hover table-responsive table-borderless"
            >
              <thead class="thead-dark">
                <tr>
                  <th></th>
                  <th scope="col">Id</th>
                  <th scope="col">Title</th>
                  <th scope="col">Client</th>
                  <th scope="col">Matchup Length</th>
                  <th scope="col">Custom order</th>
                  <th scope="col">Sequence questions</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <draggable
                v-model="packageProjects"
                @start="drag = true"
                @end="drag = false"
                tag="tbody"
              >
                <tr v-for="project in packageProjects" :key="project.data.id">
                  <td>
                    <font-awesome-icon icon="sort" />
                  </td>
                  <td scope="row">{{ project.data.id }}</td>
                  <td>
                    <b-button
                      variant="primary"
                      :to="{
                        name: 'Project',
                        params: {
                          projectId: project.data.id,
                          clientId: project.data.client_id,
                        },
                      }"
                      >{{ project.data.title }}</b-button
                    >
                  </td>
                  <td>
                    <b-link
                      :to="{
                        name: 'Client',
                        params: {
                          clientId: project.data.client_id,
                        },
                      }"
                    >
                      {{ getClient(project.data.client_id) }}
                    </b-link>
                  </td>

                  <td>
                    {{ project.data.matchup_length }}
                  </td>
                  <td>
                    {{ project.data.custom_order ? "YES" : "NO" }}
                  </td>

                  <td>
                    {{ project.data.questions_sequence }}
                  </td>
                  <td>
                    <b-button
                      variant="danger"
                      class="ml-2"
                      size="sm"
                      @click="removePackage(currentPackage.id, project.data.id)"
                    >
                      <font-awesome-icon icon="trash" class="mr-2" />
                      Remove</b-button
                    >
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
          <div v-else>
            No projects yet.
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-sidebar
      id="sidebar-formEditor"
      title="Add fields to package form"
      shadow
      width="90rem"
    >
      <FormFields />
    </b-sidebar>
    <b-sidebar
      id="sidebar-formDelete"
      title="Remove form fields from package"
      shadow
      width="90rem"
    >
      <div class="p-5">
        <b-table :items="currentPackage.form" :fields="deleteFormFields">
          <template #cell(actions)="data">
            <b-button class="text-info" @click="removeFormField(data.item.id)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-sidebar>
    <AddProjectToPackage v-bind:projects="projects" />
    <EditPackage v-bind:package="currentPackage" />
  </div>
</template>
<script>
import axios from "axios";
import draggable from "vuedraggable";
import AddProjectToPackage from "@/components/AddProjectToPackage.vue";
import EditPackage from "@/components/EditPackage.vue";
import FormFields from "@/components/FormFields.vue";
import { mapGetters } from "vuex";
import HelperImageUpload from "@/components/uploaders/HelperImageUpload.vue";

export default {
  components: {
    AddProjectToPackage,
    draggable,
    FormFields,
    EditPackage,
    HelperImageUpload,
  },
  data() {
    return {
      formFields: {},
      loading: true,
      projectsOrder: [],
      token: this.$store.state.login.token,
      apiUrl: this.$store.state.api.url,
      frontUrl: `${process.env.VUE_APP_FRONTURL}/#/package`,
      helperImgPath: `${this.$store.state.api.url}/uploads/package-${this.$route.params.packageId}/help_images`,

      sortBy: "order",
      sortDesc: false,
      projectFields: [
        {
          key: "data.title",
          label: "Project title",
          sortable: true,
        },
        {
          key: "order",
          label: "Sort Order",
          sortable: true,
        },
        {
          key: "data.client_id",
          label: "Client",
          sortable: true,
        },
        {
          key: "data.custom_order",
          label: "Custom order",
          formatter: (value) => {
            return value === true ? "Yes" : "No";
          },
        },
        {
          key: "data.matchup_length",
          label: "Matchup length",
        },
        {
          key: "data.questions_sequence",
          label: "Sequence length",
        },

        {
          key: "actions",
          label: "Actions",
        },
      ],
      deleteFormFields: [
        {
          key: "field_type",
          label: "Field type",
        },
        {
          key: "id",
          label: "ID",
        },
        {
          key: "label",
          label: "Label",
        },
        { key: "name", label: "Name" },
        {
          key: "actions",
          label: "Actions",
        },
      ],
    };
  },
  mounted: function() {},
  computed: {
    ...mapGetters({
      currentPackage: "api/getPackage",
      projects: "api/getProjects",
      getClient: "api/getClientById",
    }),
    packageProjects: {
      get() {
        return this.$store.state.api.selectedPackage.projects;
      },
      set(projects) {
        this.$store.commit("api/package_projects", projects);
      },
    },
  },
  created() {
    let packageId = this.$route.params.packageId;
    this.$store.dispatch("api/fetchPackage", packageId);
    this.$store.dispatch("api/fetchProjects");

    if (!this.$store.state.api.clients) {
      this.$store.dispatch("api/fetchClients");
    }
  },
  methods: {
    removePackage: function(packageId, projectId) {
      this.isSending = true;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/packages/${packageId}/projects/${projectId}/remove`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          method: "DELETE",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Project removed",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    updateOrder: function() {
      let newOrder = [];

      this.packageProjects.forEach(function(project, i) {
        newOrder.push({
          projectId: project.data.id,
          order: i + 1,
        });
      });

      this.isSending = true;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/packages/${this.currentPackage.id}/projects/order`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: {
            projects: newOrder,
          },
          method: "POST",
        })
          .then((response) => {
            this.isSending = false;
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            this.$router.go();

            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    removeFormField: function(id) {
      this.isSending = true;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/packages/${this.currentPackage.id}/form/remove/${id}`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          method: "DELETE",
        })
          .then((response) => {
            this.isSending = false;
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            this.$router.go();

            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
  },
};
</script>
<style>
.range-value {
  font-size: 150%;
}
</style>
